export default __webpack_public_path__ + "static/media/Angela Alberty.df49b0a0.jpg";